function updateAsyncEl() {
    if (!(window.location.pathname || '').startsWith('/cart')) return;

    const selector = '.tee-preview-button__text';
    const expected = 'Vorschau Design';

    function fix() {
        document.querySelectorAll(selector).forEach((el) => {
            if (el.textContent.trim() !== expected) el.textContent = expected;
        });
    }

    new MutationObserver(fix).observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
    });

    fix();
}

updateAsyncEl();

document.addEventListener('teeinblue-event-after-cart-added', function() {
  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      detail: {
        open: true
      }
    })
  );
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'teeinblue-event-after-cart-added',
        cart,
      });
    })
    .catch(e => {});
});